<template>
  <section class="page-api-info">
    <div v-loading="loading">
      <api-basic></api-basic>
      <div class="api-info__content">
        <api-param :callback-style="isCallbackStyleAPI"></api-param>
        <api-example :callback-style="isCallbackStyleAPI"></api-example>
        <api-error-code v-show="!isCallbackStyleAPI"></api-error-code>
        <api-history></api-history>
      </div>
    </div>
  </section>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import apiBasic from "@/components/views/doc-api/api-info-basic.vue";
import apiParam from "@/components/views/doc-api/api-info-param.vue";
import apiExample from "@/components/views/doc-api/api-info-example.vue";
import apiErrorCode from "@/components/views/doc-api/api-info-errorCode.vue";
import apiHistory from "@/components/views/doc-api/api-info-history.vue";

export default {
  name: "DocApiInfo",

  data() {
    return {
      apiCode: this.$route.params.id,
      loading: true
    };
  },
  computed: {
    ...mapState({
      dataInfo: state => state.apiDoc.apiInfo,

      // 是否为回调风格的API
      isCallbackStyleAPI: state => {
        const data = state.apiDoc.apiInfo;
        return data && data.apiCalltype == 1;
      }
    })
  },
  async mounted() {
    this.getData();
  },
  watch: {
    apiCode(val) {
      this.getData();
    },
    $route() {
      this.apiCode = this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      getApiInfo: "apiDoc/getApiInfo"
    }),
    async getData() {
      this.loading = true;
      await this.getApiInfo({ apiCode: this.apiCode });
      this.loading = false;
    }
  },
  components: { apiBasic, apiParam, apiExample, apiErrorCode, apiHistory }
};
</script>

<style lang="less">
.page-api-info {
  .api-info__content {
    margin-top: 26px;
    padding-bottom: 40px;
  }
}
</style>
